import { DSButton } from "@components/design-system/molecules";

import OttoPeek from "../../../assets/imgs/otto-peek.svg";
import ScribblesPeek from "../../../assets/imgs/scribbles-peek.svg";

export default function TemplateCTABanner({
  handleSignIn,
  handleSignUp,
  title = "Want to use this template?",
  description = "Create a free account to use or customize this template and start saving hours each week on your veterinary notes.",
}) {
  return (
    <div className="fixed inset-x-0 bottom-0 z-30 px-3 sm:px-6 pb-3 sm:pb-6">
      <div className="relative max-w-6xl mx-auto dark:bg-indigo-800 bg-indigo-200 rounded-2xl shadow-xl px-5 sm:px-8 py-4 sm:py-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 overflow-visible">
        <img
          src={OttoPeek}
          alt="Otto peeking"
          className="hidden sm:block absolute -top-14 left-4 w-32 drop-shadow-lg pointer-events-none select-none"
        />
        <img
          src={ScribblesPeek}
          alt="Scribbles peeking"
          className="hidden sm:block absolute -top-12 right-4 w-24 drop-shadow-lg pointer-events-none select-none"
        />
        <div className="sm:ml-12 sm:mr-12">
          <p className="text-base text-left sm:text-lg font-semibold dark:text-white text-gray-800">
            {title}
          </p>
          <p className="text-sm sm:text-base text-left dark:text-indigo-100 text-gray-800">
            {description}
          </p>
        </div>
        <div className="flex items-center shrink-0 gap-sm">
          <DSButton
            type="button"
            onClick={handleSignIn}
            variant="secondary"
            dataTestId="sign-in-button"
          >
            Sign In
          </DSButton>
          <DSButton
            type="button"
            onClick={handleSignUp}
            dataTestId="sign-up-button"
          >
            Sign Up Free
          </DSButton>
        </div>
      </div>
    </div>
  );
}
